import React, { useState } from "react";
import Profile from "../../images/admin logo.png";
import { useNavigate } from "react-router";
import { forgotPassword, resetPassword } from "../../api";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import { AiOutlineUser } from "react-icons/ai";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [step, setStep] = useState(1); // 1: Enter Email, 2: Enter OTP & New Password
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (step === 1) {
      try {
        await forgotPassword(email);
        toast.success('OTP sent successfully to your admin email!', {
          autoClose: 2000,
        });
        setStep(2);
      } catch (error) {
        toast.error(error.message || "Failed to send OTP", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    } else {
      try {
        await resetPassword(email, otp, newPassword);
        toast.success('Password reset successfully! Redirecting to login...', {
          onClose: () => navigate("/admin/Adminsignin"),
          autoClose: 2000,
        });
      } catch (error) {
        toast.error(error.message || "Failed to reset password. Please verify your OTP.", {
          position: "top-right",
          autoClose: 5000,
        });
      }
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="container_password">
        <div className="form-container_password">
          <img src={Profile} alt="Profile" className="profile-admin-img" />
          <h1 className="text-3xl text-center mt-3 ml-3 font-bold pb-8 fontinter">
            {step === 1 ? "Forgot Password" : "Reset Password"}
          </h1>
          <form onSubmit={handleResetPassword}>
            {step === 1 ? (
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Your Email address"
                required
                className="searchbox mb-6 w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
              />
            ) : (
              <>
                <input
                  type="text"
                  id="otp"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter OTP"
                  required
                  className="searchbox mb-4 w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
                />
                <input
                  type="password"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter New Password"
                  required
                  className="searchbox mb-6 w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out"
                />
              </>
            )}

            <button
              style={{ marginTop: "1%" }}
              className="w-full bg-blue-600 text-white px-7 py-3 text-sm font-medium uppercase rounded shadow-md hover:bg-blue-700 transition duration-150 ease-in-out hover:shadow-lg active:bg-blue-800"
              type="submit" 
            >
              {step === 1 ? "Send OTP" : "Reset Password"}
            </button>
            
            <div style={{marginTop: "4%", display: 'flex', justifyContent: 'space-between'}}>
              <Link to='/admin/Adminsignin' className="link" style={{color:"blue", textDecoration:"none"}}>
                Existing Admin User ? 
              </Link>
            </div>
          </form>
        </div>
        <Link to='/' className="user-login-link" style={{ position: 'absolute', top: '10px', right: '10px', color: 'blue', textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
          <AiOutlineUser className="user-login-icon" style={{ marginRight: '5px', fontSize: '50px' }} />
          User
        </Link>
      </div>
    </React.Fragment>
  );
}

export default ForgotPassword;
